import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { AbstractButtonComponent } from '../abstract-button.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'button[inlineButton], a[inlineButton]',
    templateUrl: 'inline-button.html',
    styleUrls: ['inline-button.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CommonModule]
})
export class InlineButtonComponent extends AbstractButtonComponent {
    // This input is just to make compiler happy.
    @Input()
    inlineButton?: any;

    @HostBinding('class._hover-state')
    @Input()
    hoverState = true;

    protected variantInputName = undefined;
}
